var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("\n    "+_vm._s(_vm.config.current_value)+" \n    "),_c('span',{staticStyle:{"font-size":"14px","color":"#cccccc"}},[_vm._v(_vm._s(_vm.unit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50faa79d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/base-loop-state.vue
// module id = null
// module chunks = 